module.exports = __webpack_public_path__ + "img/roomBannerHomeIcon.4ac7f67f.svg";